const voteList = r => require.ensure([], () => r(require('@/page/vote/voteList/voteList')), 'voteList');
const voteMge = r => require.ensure([], () => r(require('@/page/vote/voteMge')), 'voteMge');
const addVote = r => require.ensure([], () => r(require('@/page/vote/addVote/addVote')), 'addVote');
const voteDetail = r => require.ensure([], () => r(require('@/page/vote/voteDetail/voteDetail')), 'voteDetail');
const ownerManagement = r => require.ensure([], () => r(require('@/page/vote/ownerManagement/ownerManagement')), 'ownerManagement');
const voteCensor = r => require.ensure([], () => r(require('@/page/vote/voteHandle/voteCensor')), 'voteCensor');
const voteAccept = r => require.ensure([], () => r(require('@/page/vote/voteHandle/voteAccept')), 'voteAccept');
// const voteAnalysisList = r => require.ensure([], () => r(require('@/page/voteAnalysis/voteAnalysisList/voteAnalysisList')), 'voteAnalysisList');

const voteRouter={
  path:'',
  name:'投票系统',
  component:voteMge,
  meta:{icon:'vote',right: [],isShowMenu:true,keepAlive:true},
  children:[
    {path:'voteList',component:voteList,name:'投票列表',meta: {right: [],isShowMenu:true,keepAlive:true},},
    {path:'addVote',component:addVote,name:'新增投票',meta: {right: [],isShowMenu:false,keepAlive:true},},
    {path:'voteDetail',component:voteDetail,name:'投票详情',meta: {right: [],isShowMenu:false,keepAlive:true}},
    {path:'ownerManagement',component:ownerManagement,name:'业主管理',meta: {right: [],isShowMenu:true,keepAlive:true}},
    {path:'voteCensor',component:voteCensor,name:'投票审核',meta: {right: [],isShowMenu:false,keepAlive:true}},
    {path:'voteAccept',component:voteAccept,name:'投票受理',meta: {right: [],isShowMenu:false,keepAlive:true}},
    // {path:'/voteAnalysisList',component:voteAnalysisList,name:'投票综合统计列表',meta: {right: [],isShowMenu:true},},
  ]
};
export default voteRouter;
